import { render, staticRenderFns } from "./FiguresListFilter.vue?vue&type=template&id=6b99e9ea&"
import script from "./FiguresListFilter.vue?vue&type=script&lang=js&"
export * from "./FiguresListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports